export const DETAILS_CELL = 'DETAILS_CELL';
export const COMPLETED = 'status.completedStatus';
export const INVOICE_STATUS_FORM = 'INVOICE_STATUS_FORM';
